import React from 'react';
import { Link } from 'react-router-dom';
import About1 from '../../images/Commercial-Interiors2.jpg';
import { Helmet } from 'react-helmet';

const Commericalinteriors = (props) => {

      const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    
    return (
         <>
      <Helmet>
        <title>Commercial Interiors</title>
        <meta name="description" content="Make a Statement with Smart Commercial Spaces" />
        <meta name="keywords" content="about, company, mission, team" />
      </Helmet>
      <section className="wpo-about-section section-padding">
            <div className="container">
                <div className="row align-items-center">
                    
                    <div className="col-lg-6 col-12">
                        <div className="about-right">
                            <div className="text">
                                <span>About</span>
                                <h1>Commercial Interiors</h1>
                                <h6>Make a Statement with Smart Commercial Spaces</h6>
                                <p>
                                From retail showrooms to restaurants and workspaces, our commercial interior services are 
                                designed to create inspiring and engaging environments that reflect your brand identity.
                                </p>
                                <h4>Our services include :</h4>
                                <ul>
                                    <li>Store and showroom design</li>
                                    <li>Space optimization & visual merchandising</li>
                                    <li>Custom display units & fixtures</li>
                                    <li>Electrical and lighting setup</li>
                                    <li>Professional painting and finishing</li>
                                    <p>Let your business space reflect professionalism and sophistication with YATRI INTERIORS.</p>
                                </ul>
                              <a href='tel:9663222146' className='theme-btn'>Call Us: +91 96632 22146</a>
                            </div>
                        </div>
                    </div>
                
                <div className="col-lg-6 col-12">
                        <div className="about-left">
                            <img src={About1} alt="" />
                            
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
        
    )
}

export default Commericalinteriors ;